import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideLuxonDateAdapter } from '@angular/material-luxon-adapter';

export function provideLuxonDates(): EnvironmentProviders {
  return makeEnvironmentProviders([provideLuxonDateAdapter()]);
}
